import { B64File } from 'common/classes/B64File.class';
/**
 * Image de l'annonce
 */
export class AnnonceImage {
    /**
     * Constructeur de l'annonceCategorie
     * @param annonceImage à construire
     */
    constructor(annonceImage) {
        if (annonceImage) {
            const { idAnnonceImage, idAnnonce, file, actif, dateEnregistrement, url } = annonceImage;
            this.idAnnonceImage = idAnnonceImage;
            this.idAnnonce = idAnnonce;
            this.file = file !== null && file !== void 0 ? file : (url ? new B64File(B64File.pathUrlToFile(url)) : null);
            this.actif = actif;
            this.dateEnregistrement = dateEnregistrement;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        var _a;
        return {
            idAnnonceImage: this.idAnnonceImage,
            idAnnonce: this.idAnnonce,
            file: this.file.toRaw(),
            actif: this.actif,
            dateEnregistrement: (_a = this.dateEnregistrement) !== null && _a !== void 0 ? _a : null,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub25jZUltYWdlLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQW5ub25jZUltYWdlLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSw4QkFBOEIsQ0FBQztBQUl2RDs7R0FFRztBQUNILE1BQU0sT0FBTyxZQUFZO0lBK0J4Qjs7O09BR0c7SUFDSCxZQUFtQixZQUFvQztRQUN0RCxJQUFJLFlBQVksRUFBRTtZQUNqQixNQUFNLEVBQUUsY0FBYyxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsS0FBSyxFQUFFLGtCQUFrQixFQUFFLEdBQUcsRUFBRSxHQUFHLFlBQVksQ0FBQztZQUV6RixJQUFJLENBQUMsY0FBYyxHQUFHLGNBQWMsQ0FBQztZQUNyQyxJQUFJLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQztZQUMzQixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksYUFBSixJQUFJLGNBQUosSUFBSSxHQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQzNFLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO1lBQ25CLElBQUksQ0FBQyxrQkFBa0IsR0FBRyxrQkFBa0IsQ0FBQztTQUM3QztJQUNGLENBQUM7SUFFRDs7O09BR0c7SUFDSSxLQUFLOztRQUNYLE9BQU87WUFDTixjQUFjLEVBQUUsSUFBSSxDQUFDLGNBQWM7WUFDbkMsU0FBUyxFQUFFLElBQUksQ0FBQyxTQUFTO1lBQ3pCLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRTtZQUN2QixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsa0JBQWtCLEVBQUUsTUFBQSxJQUFJLENBQUMsa0JBQWtCLG1DQUFJLElBQUk7U0FDbkQsQ0FBQztJQUNILENBQUM7Q0FDRCJ9